import React from 'react'
const Buttons = (props) => {
    return (
        <div id="conectados">
            <span>{props.Users.length}</span>
            <div>
                {props.Users.map(usr => {
                    return (
                        <div
                            key={'user' + usr.id}
                            title={usr.telefono + ' - ' + usr.email}
                            style={{
                                order:usr.ts.seconds
                            }}
                        >
                            <div className='connection-time'>
                                {new Date(usr.ts.seconds*1000).toLocaleTimeString()}
                            </div>
                            <span>
                                {usr.nombre}
                            </span>
                            {usr.foto ? <img
                                src={usr.foto}
                                alt='User Pic'
                            /> : ''}
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
export default Buttons